var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    fill: "#000000",
    id: "svg53",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs57"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 24 V 24 H 0 Z",
    fill: "none",
    id: "path49"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 18,20 H 4 V 6 h 9 V 4 H 4 C 2.9,4 2,4.9 2,6 v 14 c 0,1.1 0.9,2 2,2 h 14 c 1.1,0 2,-0.9 2,-2 V 11 H 18 Z M 10.21,16.83 8.25,14.47 5.5,18 h 11 L 12.96,13.29 Z M 20,4 V 1 h -2 v 3 h -3 c 0.01,0.01 0,2 0,2 h 3 v 2.99 c 0.01,0.01 2,0 2,0 V 6 h 3 V 4 Z",
    id: "path51",
    style: {
      fill: "#214ba5",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddImage);
export default __webpack_public_path__ + "static/media/add-image.438f3b2a683fcb3ecebd2d41e9ee841b.svg";
export { ForwardRef as ReactComponent };